<div class="frontpage-widget cover-image-mose-gray">
    <div class="whitebox gray">
        <div class="container">
            <p class="text-muted">RISIKOVURDERING <i class="fa fa-chevron-right"></i></p>
            <h2 i18n>Angiv parametre</h2>
            <p>
                <span class="text-muted">
                    &nbsp;&nbsp;&nbsp;<i class="fa fa-map-marker"></i> Lokalitet:
                </span>
                <a href="riskassessment/location-details/{{locationId}}">{{locationName}}</a></p>
            <p i18n>
                <span class="text-muted">Lokalitetsnummer: </span>{{locationNumber}}
            </p>
        </div>
    </div>
</div>
<div class="container">
    <div *ngIf="loading" class="mt-5 text-center">
        <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
        <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter parametersiden... </h3>
        <p class="text-muted mt-1">Det tager et øjeblik</p>

    </div>

    <form *ngIf="!loading" (ngSubmit)="startCalculation()" ngNativeValidate autocomplete="off">
        <div class="row mt-5">
            <div class="col-sm-12 col-lg-4">

                <div class="form-group">
                    <label for="contaminant">Forureningsstof:</label>
                    <input
                        [formControl]="contaminantNameControl"
                        [matAutocomplete]="contaminantAutoComplete"
                        name="contaminant"
                        type="text"
                        placeholder="Vælg forureningsstof"
                        title="Vælg stof fra listen."
                        class="form-control text-input"
                        required />
                    <mat-autocomplete
                        #contaminantAutoComplete="matAutocomplete"
                        autoActiveFirstOption>
                        <mat-option *ngFor="let compound of filteredCompoundList" [value]="compound.name">
                            {{ compound.alternativeName ? (compound.name + " | " + compound.alternativeName) : compound.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <div *ngIf="contaminantNameControl.hasError('contaminantName')">
                        <p class="text-danger">
                            Det indtastede matcher ikke noget på beregningsstoflisten, som er det eneste tilladte
                        </p>
                    </div>
                </div>

                <div class="form-group">
                    <label for="calculationmodel">Beregningsmodel:</label>
                    <div class="dropdown" id="calculationmodel">
                        <a class="btn btn-outline-secondary dropdown-toggle" href="javascript:void(0)" role="button"
                            id="dropdownMenuLink" data-toggle="dropdown">
                            <span class="model-indicator">
                                <i class="model-icon"></i>
                                <span class="model-number">{{calculationInput.modelType}}</span>
                            </span>
                            {{calculationModelNames[calculationInput.modelType]}}
                        </a>

                        <div class="dropdown-menu">
                            <a class="dropdown-item" (click)="setModel(calculationModelType.ModelI);">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">1</span>
                                </span> {{calculationModelNames[1]}}
                            </a>
                            <a class="dropdown-item" (click)="setModel(calculationModelType.ModelII);">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">2</span>
                                </span> {{calculationModelNames[2]}}
                            </a>
                            <a class="dropdown-item" (click)="setModel(calculationModelType.ModelIII);">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">3</span>
                                </span> {{calculationModelNames[3]}}
                            </a>
                            <a class="dropdown-item" (click)="setModel(calculationModelType.ModelIV);">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">4</span>
                                </span> {{calculationModelNames[4]}}
                            </a>
                            <a class="dropdown-item" (click)="setModel(calculationModelType.ModelV);">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">5</span>
                                </span> {{calculationModelNames[5]}}
                            </a>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="calculationmodel">Nedbrydningsmodel:</label>
                    <div class="dropdown" id="calculationmodel">
                        <a class="btn btn-outline-secondary dropdown-toggle" href="javascript:void(0)" role="button"
                            id="dropdownMenuLink" data-toggle="dropdown">
                            <span *ngIf="(!calculationInput || !calculationInput.degradation)" class="text-muted">Vælg
                                nedbrydning...</span>
                            <span *ngIf="(calculationInput && calculationInput.degradation)"
                                [ngSwitch]="calculationInput.degradation">
                                <span *ngSwitchCase="degradation.None">Ingen nedbrydning</span>
                                <span *ngSwitchCase="degradation.Simple">1. ordens nedbrydning</span>
                                <span *ngSwitchCase="degradation.Sequential">Sekventiel 1. ordens nedbrydning</span>
                            </span>
                        </a>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" (click)="setDegradation(degradation.None);">Ingen nedbrydning</a>
                            <a class="dropdown-item" (click)="setDegradation(degradation.Simple);">1. ordens nedbrydning</a>
                            <a *ngIf="canSelectSequentialDegradation" class="dropdown-item" (click)="setDegradation(degradation.Sequential);">Sekventiel 1. ordens nedbrydning</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-lg-2 mt-3">
                <div class="v-rule"></div>
            </div>

            <div class="col-sm-12 col-lg-6 ml-auto align-center mt-5">
                <div class="mb-4">
                    <p i18n>Udfyld alle parametre og tryk start når du er klar. <b>OBS!</b> Afhængigt af beregningsmodel kan
                        beregningen tage op til 20 min.</p>
                    <button class="btn btn-secondary" [disabled]="!contaminantNameControl.valid || isStarting">
                        <b>{{ (isStarting ? 'STARTING...' : 'START') }} <i class="fa fa-play-circle-o fa-lg"></i></b>
                    </button>
                </div>
                <div>
                    <button 
                        type="button" class="btn btn-secondary" 
                        title="Data for infiltration, tykkelse af dæklag,&#10;dybde til grundvandsmagasin&#10;og hydraulisk gradient hentes fra GEUS beregneren.&#10;&#10;For mere info henvises til GrundRisk baggrundsmateriale."
                        [disabled]="startingGeuscalculation && !locationNumber"
                        [hidden]="hideStartGeusButton"
                        (click)="startGeuscalculation()">
                        Hent Geologisk data
                    </button>
                </div>
                <div v-if="errorGeusCalculation" class="mt-3">
                    <p class="text-danger">
                        {{ errorGeusCalculation }}
                    </p>
                </div>
                <button id="toggleGeusDataCalculateModalButton" type="button" data-toggle="modal" class="d-none" data-target="#geusDataCalculateModal"></button>

                <div>
                    <button *ngIf="!hideGetDataFromGeuscalculator" id="#geusDataModalButton" type="button" class="btn btn-secondary" data-toggle="modal" data-target="#geusDataModal">
                        Hent data fra Geusberegneren
                    </button>
                </div>
            </div>
        </div>

        <!-- Forureningskilde -->
        <div class="row mt-5">
            <div class="col">
                <h3 class="calculation-section-header"><span i18n>Forureningskilde</span></h3>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-lg-4 mt-3">
                <div class="form-group">
                    <label>Kildekoncentration, <ng-katex [equation]="'C_0'"></ng-katex> (µg/L):</label>
                    <div class="mt-1" *ngFor="let compound of degradationCompoundList; let i = index">
                        <label>{{compound.name}}:</label>
                        <div>
                            <input name="sourceConcentration-{{compound.name}}"
                                [ngModel]="calculationInput.sourceConcentration[i] | expNumber : 'sourceConcentration' + i : tempParameters "
                                (ngModelChange)="calculationInput.sourceConcentration[i] = localizedParseFloat($event, 'sourceConcentration' + i);"
                                placeholder="Indtast koncentration..." type="text" class="form-control text-input"
                                required />
                        </div>
                    </div>
                </div>

                <div class="form-group" *ngIf="(calculationInput.modelType != calculationModelType.ModelIV)">
                    <label>Længde af kilde, <ng-katex [equation]="'L_x'"></ng-katex> (m):</label>
                    <div>
                        <input name="sourceLength"
                            [ngModel]="calculationInput.sourceLength | expNumber : 'sourceLength' : tempParameters "
                            (ngModelChange)="calculationInput.sourceLength = localizedParseFloat($event, 'sourceLength');"
                            placeholder="Indtast længde..." type="text" class="form-control text-input" required />
                    </div>
                </div>

                <div class="form-group" *ngIf="(calculationInput.modelType != calculationModelType.ModelIV)">
                    <label>Bredde af kilde, <ng-katex [equation]="'L_y'"></ng-katex> (m):</label>
                    <div>
                        <input name="sourceWidth"
                            [ngModel]="calculationInput.sourceWidth |  expNumber : 'sourceWidth' : tempParameters"
                            (ngModelChange)="calculationInput.sourceWidth=localizedParseFloat($event, 'sourceWidth');"
                            placeholder="Indtast bredde..." type="text" class="form-control text-input" required />
                    </div>
                </div>

                <div class="form-group" *ngIf="(calculationInput.modelType != calculationModelType.ModelIV)">
                    <label>Infiltration i kildeområde, <ng-katex [equation]="'I_{kilde}'"></ng-katex> (mm/år):</label>
                    <div
                        [ngClass]="{
                            'input-label screening-value' : (screeningData && calculationInput.sourceInfiltration === screeningData.infiltration),
                            'input-label geus-calc-value': (selectedGeusDataItem && calculationInput.sourceInfiltration === roundNumber(selectedGeusDataItem.infiltration))
                        }">
                        <input name="sourceInfiltration"
                            [ngModel]="calculationInput.sourceInfiltration | expNumber : 'sourceInfiltration' : tempParameters"
                            (ngModelChange)="calculationInput.sourceInfiltration = localizedParseFloat($event, 'sourceInfiltration');"
                            placeholder="Indtast infiltration..." type="text" class="form-control text-input"
                            required />
                    </div>
                </div>

                <div class="form-group" *ngIf="(calculationInput.modelType == calculationModelType.ModelIV)">
                    <label>Radius af kildeområde, <ng-katex [equation]="'r'"></ng-katex> (m):</label>
                    <div>
                        <input name="sourceRadius"
                            [ngModel]="calculationInput.sourceRadius | expNumber : 'sourceRadius' : tempParameters"
                            (ngModelChange)="calculationInput.sourceRadius = localizedParseFloat($event, 'sourceRadius');"
                            placeholder="Indtast radius..." type="text" class="form-control text-input" required />
                    </div>
                </div>

                <div class="form-group" *ngIf="(calculationInput.modelType == calculationModelType.ModelIV)">
                    <label>Grænseradius, hvor koncentrationen antages lig nul, <ng-katex [equation]="'r_2'"></ng-katex>
                        (m):</label>
                    <div>
                        <input name="concentrationZeroRadius"
                            [ngModel]="calculationInput.concentrationZeroRadius | expNumber : 'concentrationZeroRadius' : tempParameters"
                            (ngModelChange)="calculationInput.concentrationZeroRadius = localizedParseFloat($event, 'concentrationZeroRadius');"
                            placeholder="Indtast radius..." type="text" class="form-control text-input" required />
                    </div>

                    <div>
                        <label>Bemærk: Det er kun nødvendigt at indtaste en grænseradius, hvis der ikke sker nedbrydning
                            i den umættede zone</label>
                    </div>
                </div>

                <div class="form-group">
                    <label>Infiltration over fanen, <ng-katex [equation]="'I_{fane}'"></ng-katex> (mm/år):</label>
                    <div
                        [ngClass]="{
                            'input-label screening-value' : (screeningData && calculationInput.plumeInfiltration === screeningData.infiltration),
                            'input-label geus-calc-value' : (selectedGeusDataItem && calculationInput.plumeInfiltration === roundNumber(selectedGeusDataItem.infiltration))
                        }">
                        <input name="plumeInfiltration"
                            [ngModel]="calculationInput.plumeInfiltration | expNumber : 'plumeInfiltration' : tempParameters"
                            (ngModelChange)="calculationInput.plumeInfiltration = localizedParseFloat($event, 'plumeInfiltration');"
                            placeholder="Indtast infiltration..." type="text" class="form-control text-input"
                            required />
                    </div>
                    <div *ngIf="(calculationInput.modelType == calculationModelType.ModelIII)">
                        <label>Bemærk: <ng-katex [equation]="'I_{fane}'"></ng-katex> skal være lig <ng-katex [equation]="'I_{kilde}'"></ng-katex></label>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-lg-2 mt-3">
                <div class="v-rule"></div>
            </div>

            <div class="col-sm-12 col-lg-6 mt-3">
                <div class="image-card model-image-card" style="width:100%; height:320px;padding: 1rem">
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelI" class="helper-img"
                        style="background-image: url('../assets/Model1_pollution_source2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelII" class="helper-img"
                        style="background-image: url('../assets/Model2_pollution_source2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelIII" class="helper-img"
                        style="background-image: url('../assets/Model3_pollution_source2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelIV" class="helper-img"
                        style="background-image: url('../assets/Model4_pollution_source2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelV" class="helper-img"
                        style="background-image: url('../assets/Model5_pollution_source2.png'); "></div>
                </div>

                <div class="form-group mt-5">
                    <label for="pollutionSourceComment">Tilføj kommentar til forureningskilde</label>
                    <textarea
                        class="form-control"
                        placeholder="Skriv kommentar..."
                        rows="5"
                        name = "pollutionSourceComment"
                        [(ngModel)]="calculationInput.pollutionSourceComment">
                    </textarea>
                </div>
            </div>
        </div>

        <!-- Vertikal transport -->
        <ng-container *ngIf="(calculationInput.modelType != calculationModelType.ModelV)">
            <div class="row mt-5">
                <div class="col">
                    <h3 class="calculation-section-header"><span i18n>Vertikal transport</span></h3>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-lg-4 mt-3">
                    <div class="form-group" *ngIf="(calculationInput.modelType != calculationModelType.ModelIV)">
                        <label>Afstand fra kilde til top af grundvandsmagasin, <ng-katex [equation]="'Z_v'"></ng-katex>
                            (m):</label>
                        <div
                            [ngClass]="{
                                'input-label screening-value' : (screeningData && calculationInput.sourceToAquiferDist === screeningData.aquiferDepth),
                                'input-label geus-calc-value' : (selectedGeusDataItem && calculationInput.sourceToAquiferDist === roundNumber(selectedGeusDataItem.aquiferDepth))
                            }">
                            <input name="sourceToAquiferDist"
                                [ngModel]="calculationInput.sourceToAquiferDist | expNumber : 'sourceToAquiferDist' : tempParameters"
                                (ngModelChange)="calculationInput.sourceToAquiferDist = localizedParseFloat($event, 'sourceToAquiferDist');"
                                placeholder="Indtast afstand..." type="text" class="form-control text-input" required />
                        </div>
                    </div>

                    <div class="form-group" *ngIf="(calculationInput.modelType == calculationModelType.ModelIV)">
                        <label>Kapillarzonens dybde, <ng-katex [equation]="'f'"></ng-katex> (m):</label>
                        <div>
                            <input name="capillaryFringe"
                                [ngModel]="calculationInput.capillaryFringe | expNumber : 'capillaryFringe' : tempParameters"
                                (ngModelChange)="calculationInput.capillaryFringe = localizedParseFloat($event, 'capillaryFringe');"
                                placeholder="Indtast dybde..." type="text" class="form-control text-input" required />
                        </div>
                        <label>
                            Anbefalet værdi 0,17m (sand) og 0,19m (leret sand)
                        </label>
                    </div>

                    <div class="form-group">
                        <label>Jordtype</label>
                        <div>
                            <label class="form-check-inline">
                                <input type="radio" name="selectedGroundTypeRB" [value]="0"
                                    [(ngModel)]="selectedGroundType">
                                <span i18n> Fed ler</span>
                            </label>
                            <label class="form-check-inline">
                                <input type="radio" name="selectedGroundTypeRB" [value]="1"
                                    [(ngModel)]="selectedGroundType">
                                <span i18n> Moræneler, sandet/siltet ler</span>
                            </label>
                            <label class="form-check-inline">
                                <input type="radio" name="selectedGroundTypeRB" [value]="2"
                                    [(ngModel)]="selectedGroundType">
                                <span i18n> Sand</span>
                            </label>
                            <label class="form-check-inline">
                                <input type="radio" name="selectedGroundTypeRB" [value]="3"
                                    [(ngModel)]="selectedGroundType">
                                <span i18n> Silt (morænesilt)</span>
                            </label>
                            <label class="form-check-inline">
                                <input type="radio" name="selectedGroundTypeRB" [value]="4"
                                    [(ngModel)]="selectedGroundType">
                                <span i18n> Sand og grus (usorteret)</span>
                            </label>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Porøsitet, <ng-katex [equation]="'\\epsilon'"></ng-katex>:</label>
                        <div
                            [ngClass]="{'input-label recommended-value' : calculationInput.verticalPorosity == verticalPorosityRecommendedValue}">
                            <input name="verticalPorosity"
                                [ngModel]="calculationInput.verticalPorosity | expNumber : 'verticalPorosity' : tempParameters"
                                (ngModelChange)="calculationInput.verticalPorosity=localizedParseFloat($event, 'verticalPorosity');refreshGroundwaterVelocity();"
                                placeholder="Indtast porøsitet..." type="text" class="form-control text-input"
                                (change)="changeVerticalPorosity();"
                                required />
                        </div>
                        <div>
                            <label>Min:
                                {{verticalPorosityMinValue | expNumber : 'verticalPorosityMinValue' : tempParameters}} -
                                Anbefalet:
                                {{verticalPorosityRecommendedValue | expNumber : 'verticalPorosityRecommendedValue' : tempParameters}}
                                - Max:
                                {{verticalPorosityMaxValue | expNumber : 'verticalPorosityMaxValue' : tempParameters}}</label>
                        </div>
                    </div>

                    <div class="form-group"
                        *ngIf="(calculationInput.modelType == calculationModelType.ModelIII || calculationInput.modelType == calculationModelType.ModelIV)">
                        <label>Vandindhold, <ng-katex [equation]="'V_v'"></ng-katex>:</label>
                        <div
                            [ngClass]="{'input-label recommended-value' : calculationInput.waterContent == verticalWaterContentRecommendedValue}">
                            <input name="waterContent"
                                [ngModel]="calculationInput.waterContent | expNumber : 'waterContent' : tempParameters"
                                (ngModelChange)="calculationInput.waterContent=localizedParseFloat($event, 'waterContent');refreshGroundwaterVelocity();"
                                placeholder="Indtast porøsitet..." type="text" class="form-control text-input"
                                (change)="verifyWaterContent();"
                                required />
                        </div>
                        <div>
                            <label>Min: {{verticalWaterContentMinValue | number:'1.0-10'}} - Anbefalet:
                                {{verticalWaterContentRecommendedValue | number:'1.0-10'}} - Max:
                                {{verticalWaterContentMaxValue | number:'1.0-10'}}</label>
                        </div>
                    </div>

                    <div class="form-group"
                        *ngIf="((calculationInput.modelType != calculationModelType.ModelIV) && (calculationInput.modelType != calculationModelType.ModelII))">
                        <label>Longitudinal dispersivitet (z-retning), <ng-katex [equation]="'\\alpha_{L,v}'">
                            </ng-katex> (m):</label>
                        <div
                            [ngClass]="{'input-label default-value' : calculationInput.verticalLongitudinalDispersivity == modelDefaultValues.verticalLongitudinalDispersivity}">
                            <input name="verticalLongitudinalDispersivity"
                                [ngModel]="calculationInput.verticalLongitudinalDispersivity | expNumber : 'verticalLongitudinalDispersivity' : tempParameters"
                                (ngModelChange)="calculationInput.verticalLongitudinalDispersivity=localizedParseFloat($event, 'verticalLongitudinalDispersivity');"
                                placeholder="Indtast dispersitivitet..." type="text" class="form-control text-input"
                                required />
                        </div>
                    </div>

                    <div class="form-group" *ngIf="(calculationInput.modelType == calculationModelType.ModelIII)">
                        <label>Transversal dispersivitet (y-retning), <ng-katex [equation]="'\\alpha_{T,v}'"></ng-katex>
                            (m):</label>
                        <div
                            [ngClass]="{'input-label default-value' : calculationInput.verticalTransversalDispersivity == modelDefaultValues.verticalTransversalDispersivity}">
                            <input name="verticalTransversalDispersivity"
                                [ngModel]="calculationInput.verticalTransversalDispersivity | expNumber : 'verticalTransversalDispersivity' : tempParameters"
                                (ngModelChange)="calculationInput.verticalTransversalDispersivity=localizedParseFloat($event, 'verticalTransversalDispersivity');"
                                placeholder="Indtast dispersitivitet..." type="text" class="form-control text-input"
                                required />
                        </div>
                    </div>

                    <ng-container
                        *ngIf="(
                        (calculationInput.modelType == calculationModelType.ModelI && (calculationInput.degradation != degradation.None)) ||
                        (calculationInput.modelType == calculationModelType.ModelII && (calculationInput.degradation != degradation.None)) ||
                        (calculationInput.modelType == calculationModelType.ModelIII && (calculationInput.degradation == degradation.Simple)) ||
                        (calculationInput.modelType == calculationModelType.ModelIV && (calculationInput.degradation == degradation.Simple)))">
                        <div class="form-group">
                            <label>1. ordens nedbrydningsrate, <ng-katex [equation]="'k_v'"></ng-katex>
                                (d<sup>-1</sup>):</label>
                            <div class="mt-1" *ngFor="let compound of degradationCompoundList; let i = index">
                                <label>{{compound.name}}:</label>
                                <div
                                    [ngClass]="{
                                        'input-label recommended-anaerobic-rate' : calculationInput.verticalFirstOrderDegradationRate[i] === getVerticalFirstOrderDegrationRate(compound)}">
                                    <input name="verticalFirstOrderDegradationRate-{{compound.name}}"
                                        [ngModel]="calculationInput.verticalFirstOrderDegradationRate[i] | expNumber : 'verticalFirstOrderDegradationRate' + i : tempParameters"
                                        (ngModelChange)="calculationInput.verticalFirstOrderDegradationRate[i]=localizedParseFloat($event, 'verticalFirstOrderDegradationRate' + i);"
                                        placeholder="Indtast rate..." type="text"
                                        class="form-control text-input" required />
                                </div>
                                <label>
                                    Nedbrydningsraten er den anbefalede anaerobe nedbrydningsrate for stoffet. Der bør foretages en vurdering af hvilken rate, der skal benyttes
                                </label>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="(calculationInput.modelType == calculationModelType.ModelII)">
                        <div class="form-group">
                            <label>Sprækkeafstand, <ng-katex [equation]="'2B'"></ng-katex> (m):</label>
                            <div
                                [ngClass]="{'input-label default-value' : calculationInput.fractureSpacing == modelDefaultValues.fractureSpacing}">
                                <input name="fractureSpacing"
                                    [ngModel]="calculationInput.fractureSpacing | expNumber : 'fractureSpacing' : tempParameters"
                                    (ngModelChange)="setFractureSpacing(localizedParseFloat($event, 'fractureSpacing'));"
                                    placeholder="Indtast afstand..." type="text" class="form-control text-input"
                                    required />
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Sprækkeapertur, <ng-katex [equation]="'2b'"></ng-katex> (m):</label>
                            <div>
                                <label class="form-check-inline">
                                    <input type="radio" name="calculateFractureAperture" [value]="false"
                                        [(ngModel)]="calculateFractureAperture">
                                    <span i18n> Indtast</span>
                                </label>
                                <label class="form-check-inline">
                                    <input type="radio" name="calculateFractureAperture" [value]="true"
                                        [(ngModel)]="calculateFractureAperture">
                                    <span i18n> Beregn</span>
                                </label>
                            </div>
                            <div *ngIf="calculationInput.calculateFractureAperture" class="input-label computed-value">
                                <div>
                                    <input name="fractureAperture"
                                        [ngModel]="calculationInput.fractureAperture | expNumber : 'fractureAperture' : tempParameters"
                                        type="text" class="form-control text-input" disabled />
                                </div>
                                <div class="mt-1">
                                    <span i18n><label>Udregnes som </label>
                                        <ng-katex class="large-font-size-for-equation" [equation]="Two_b_equation"
                                            [options]="options"></ng-katex>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="!calculationInput.calculateFractureAperture">
                                <input name="fractureAperture"
                                    [ngModel]="calculationInput.fractureAperture | expNumber : 'fractureAperture' : tempParameters"
                                    (ngModelChange)="setFractureAperture(localizedParseFloat($event, 'fractureAperture'));"
                                    placeholder="Indtast apertur..." type="text" class="form-control text-input"
                                    required />
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Bulk hydraulisk konduktivitet, <ng-katex [equation]="'K_b'"></ng-katex>
                                (m/s):</label>
                            <div *ngIf="!calculationInput.calculateFractureAperture" class="input-label computed-value">
                                <div>
                                    <input name="bulkHydraulicConductivity"
                                        [ngModel]="calculationInput.bulkHydraulicConductivity | expNumber : 'bulkHydraulicConductivity' : tempParameters"
                                        type="text" class="form-control text-input" disabled />
                                </div>
                                <div class="mt-1">
                                    <span i18n><label>Udregnes som </label>
                                        <ng-katex class="large-font-size-for-equation" [equation]="K_b_equation"
                                            [options]="options"></ng-katex>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="calculationInput.calculateFractureAperture"
                                [ngClass]="{'input-label default-value' : calculationInput.bulkHydraulicConductivity == modelDefaultValues.bulkHydraulicConductivity}">
                                <input name="bulkHydraulicConductivity"
                                    [ngModel]="calculationInput.bulkHydraulicConductivity | expNumber : 'bulkHydraulicConductivity' : tempParameters"
                                    (ngModelChange)="setBulkHydraulicConductivity(localizedParseFloat($event, 'bulkHydraulicConductivity'));"
                                    placeholder="Indtast konduktivitet..." type="text" class="form-control text-input"
                                    required />
                            </div>
                        </div>
                    </ng-container>

                </div>

                <div class="col-sm-12 col-lg-2 mt-3">
                    <div class="v-rule"></div>
                </div>

                <div class="col-sm-12 col-lg-6 mt-3">
                    <div class="image-card model-image-card" style="width:100%; height:320px;padding: 1rem">
                        <div *ngIf="calculationInput.modelType == calculationModelType.ModelI" class="helper-img"
                            style="background-image: url('../assets/Model1_vertical_transport2.png'); "></div>
                        <div *ngIf="calculationInput.modelType == calculationModelType.ModelII" class="helper-img"
                            style="background-image: url('../assets/Model2_vertical_transport2.png'); "></div>
                        <div *ngIf="calculationInput.modelType == calculationModelType.ModelIII" class="helper-img"
                            style="background-image: url('../assets/Model3_vertical_transport2.png'); "></div>
                        <div *ngIf="calculationInput.modelType == calculationModelType.ModelIV" class="helper-img"
                            style="background-image: url('../assets/Model4_vertical_transport2.png'); "></div>
                        <!-- <div *ngIf="calculationInput.modelType == calculationModelType.ModelV" class="helper-img" style="background-image: url('../assets/Model5_vertical_transport2.png'); "></div> -->
                    </div>

                    <div class="form-group mt-5">
                        <label for="exampleFormControlTextarea1">Tilføj kommentar til vertikal transport</label>
                        <textarea class="form-control"
                            (change)="calculationInput.verticalTransportComment = $event.target.value;"
                            placeholder="Skriv kommentar..."
                            rows="3">{{calculationInput.verticalTransportComment}}</textarea>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Horisontal transport -->
        <div class="row mt-5">
            <div class="col">
                <h3 class="calculation-section-header"><span i18n>Horisontal transport</span></h3>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-lg-4 mt-3">
                <div class="form-group">
                    <label>
                        Mægtighed af grundvandsmagasinet (fra top til bund),
                        <ng-katex [equation]="'d'"></ng-katex>
                        (m):
                    </label>
                    <div>
                        <input name="aquiferThickness"
                            [ngModel]="calculationInput.aquiferThickness | expNumber : 'aquiferThickness' : tempParameters"
                            (ngModelChange)="calculationInput.aquiferThickness=localizedParseFloat($event, 'aquiferThickness');"
                            placeholder="Indtast dybde..." type="text" class="form-control text-input" required />
                    </div>
                </div>

                <div class="form-group">
                    <label>Grundvandshastighed, <ng-katex [equation]="'u'"></ng-katex> (m/år):</label>

                    <div>
                        <label class="form-check-inline">
                            <input type="radio" name="calculateGroundwaterVelocity" [value]="false"
                                [(ngModel)]="calculateGroundwaterVelocity">
                            <span i18n> Indtast</span>
                        </label>
                        <label class="form-check-inline">
                            <input type="radio" name="calculateGroundwaterVelocity" [value]="true"
                                [(ngModel)]="calculateGroundwaterVelocity">
                            <span i18n> Beregn</span>
                        </label>
                    </div>
                    <div *ngIf="!calculationInput.calculateGroundwaterVelocity">
                        <input name="groundwaterVelocity"
                            [ngModel]="calculationInput.groundwaterVelocity | expNumber : 'groundwaterVelocity' : tempParameters"
                            (ngModelChange)="calculationInput.groundwaterVelocity=localizedParseFloat($event, 'groundwaterVelocity');"
                            placeholder="Indtast hastighed..." type="text" class="form-control text-input" required />
                    </div>
                    <div *ngIf="calculationInput.calculateGroundwaterVelocity" class="input-label computed-value">
                        <div>
                            <input name="groundwaterVelocity"
                                [ngModel]="calculationInput.groundwaterVelocity | expNumber : 'groundwaterVelocity' : tempParameters"
                                type="text" class="form-control text-input" disabled />
                        </div>
                        <div class="mt-1">
                            <span i18n><label>Udregnes som </label>
                                <ng-katex class="large-font-size-for-equation" [equation]="u_equation"
                                    [options]="options"></ng-katex>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Magasintype</label>
                    <div>
                        <label class="form-check-inline">
                            <input type="radio" name="selectedMagasintypeRB" [value]="0"
                                [(ngModel)]="selectedMagasinType">
                            <span i18n> Kvartært sand</span>
                        </label>
                        <label class="form-check-inline">
                            <input type="radio" name="selectedMagasintypeRB" [value]="1"
                                [(ngModel)]="selectedMagasinType">
                            <span i18n> Prækvartært sand</span>
                        </label>
                        <label class="form-check-inline">
                            <input type="radio" name="selectedMagasintypeRB" [value]="2"
                                [(ngModel)]="selectedMagasinType">
                            <span i18n> Opsprækket kalk</span>
                        </label>
                    </div>
                </div>

                <ng-container *ngIf="calculationInput.calculateGroundwaterVelocity">
                    <div class="form-group">
                        <label>Hydraulisk konduktivitet, <ng-katex [equation]="'K'"></ng-katex> (m/s):</label>
                        <div
                            [ngClass]="{'input-label recommended-value' : calculationInput.hydraulicConductivity == horizontalHydraulicConductivityRecommendedValue}">
                            <input name="hydraulicConductivity"
                                [ngModel]="calculationInput.hydraulicConductivity | expNumber : 'hydraulicConductivity' : tempParameters"
                                (ngModelChange)="calculationInput.hydraulicConductivity=localizedParseFloat($event, 'hydraulicConductivity');refreshGroundwaterVelocity();"
                                placeholder="Indtast konduktivitet..." type="text" class="form-control text-input"
                                required />
                        </div>
                        <div>
                            <label>Min:
                                {{horizontalHydraulicConductivityMinValue | expNumber : 'horizontalHydraulicConductivityMinValue' : tempParameters}}
                                - Anbefalet:
                                {{horizontalHydraulicConductivityRecommendedValue |  expNumber : 'horizontalHydraulicConductivityRecommendedValue' : tempParameters}}
                                - Max:
                                {{horizontalHydraulicConductivityMaxValue |  expNumber : 'horizontalHydraulicConductivityMaxValue' : tempParameters}}</label>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Hydraulisk gradient, <ng-katex [equation]="'i'"></ng-katex>:</label>
                        <div [ngClass]="{
                            'input-label geus-calc-value' : (selectedGeusDataItem && calculationInput.hydraulicGradient === selectedGeusDataItem.headGradient)
                        }">
                            <input name="hydraulicGradient"
                                [ngModel]="calculationInput.hydraulicGradient | expNumber : 'hydraulicGradient' : tempParameters"
                                (ngModelChange)="calculationInput.hydraulicGradient=localizedParseFloat($event, 'hydraulicGradient');refreshGroundwaterVelocity();"
                                placeholder="Indtast gradient..." type="text" class="form-control text-input"
                                required />
                        </div>
                    </div>
                </ng-container>


                <div class="form-group">
                    <label>Porøsitet, <ng-katex [equation]="'n'"></ng-katex>:</label>
                    <div
                        [ngClass]="{'input-label recommended-value' : calculationInput.horizontalPorosity == horizontalPorosityRecommendedValue}">
                        <input name="horizontalPorosity"
                            [ngModel]="calculationInput.horizontalPorosity | expNumber : 'horizontalPorosity' : tempParameters"
                            (ngModelChange)="calculationInput.horizontalPorosity=localizedParseFloat($event, 'horizontalPorosity');refreshGroundwaterVelocity();"
                            placeholder="Indtast porøsitet..." type="text" class="form-control text-input" required />
                    </div>
                    <div>
                        <label>Min:
                            {{horizontalPorosityMinValue | expNumber : 'horizontalPorosityMinValue' : tempParameters}} -
                            Anbefalet:
                            {{horizontalPorosityRecommendedValue | expNumber : 'horizontalPorosityRecommendedValue' : tempParameters}}
                            - Max:
                            {{horizontalPorosityMaxValue | expNumber : 'horizontalPorosityMaxValue' : tempParameters}}</label>
                    </div>
                </div>

                <div class="form-group" *ngIf="calculationInput.degradation != degradation.None">
                    <label>1. ordens nedbrydningsrate, <ng-katex [equation]="'k'"></ng-katex> (d<sup>-1</sup>):</label>
                    <div>
                        <label class="form-check-inline">
                            <input type="radio" name="aerobicDegradation" [value]="true"
                                [(ngModel)]="aerobicDegradation">
                            <span i18n> Aerobe forhold</span>
                        </label>
                        <label class="form-check-inline">
                            <input type="radio" name="aerobicDegradation" [value]="false"
                                [(ngModel)]="aerobicDegradation">
                            <span i18n> Anaerobe forhold</span>
                        </label>
                    </div>
                    <div *ngFor="let compound of degradationCompoundList; let i = index">
                        <label>{{compound.name}}:</label>
                        <div
                            [ngClass]="{'input-label recommended-value' : calculationInput.horizontalFirstOrderDegradationRate[i] == (aerobicDegradation ? compound.horizontalFirstOrderDegradationRateAerobicAverage : compound.horizontalFirstOrderDegradationRateAnaerobicAverage)}">
                            <input name="horizontalFirstOrderDegradationRate-{{compound.name}}"
                                [ngModel]="calculationInput.horizontalFirstOrderDegradationRate[i] | expNumber : 'horizontalFirstOrderDegradationRate' + i : tempParameters"
                                (ngModelChange)="calculationInput.horizontalFirstOrderDegradationRate[i]=localizedParseFloat($event, 'horizontalFirstOrderDegradationRate' + i);"
                                placeholder="Indtast koncentration..." type="text" class="form-control text-input"
                                required />
                        </div>
                        <div>
                            <label *ngIf="aerobicDegradation">Min:
                                {{compound.horizontalFirstOrderDegradationRateAerobicMin | expNumber : 'horizontalFirstOrderDegradationRateAerobicMin' : tempParameters}}
                                - Middel:
                                {{compound.horizontalFirstOrderDegradationRateAerobicAverage | expNumber : 'horizontalFirstOrderDegradationRateAerobicAverage' : tempParameters}}
                                - Max:
                                {{compound.horizontalFirstOrderDegradationRateAerobicMax | expNumber : 'horizontalFirstOrderDegradationRateAerobicMax' : tempParameters}}</label>
                            <label *ngIf="!aerobicDegradation">Min:
                                {{compound.horizontalFirstOrderDegradationRateAnaerobicMin | expNumber : 'horizontalFirstOrderDegradationRateAnaerobicMin' : tempParameters}}
                                - Middel:
                                {{compound.horizontalFirstOrderDegradationRateAnaerobicAverage |  expNumber : 'horizontalFirstOrderDegradationRateAnaerobicAverage' : tempParameters}}
                                - Max:
                                {{compound.horizontalFirstOrderDegradationRateAnaerobicMax | expNumber : 'horizontalFirstOrderDegradationRateAnaerobicMax' : tempParameters}}</label>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Longitudinal dispersivitet (x-retning), <ng-katex [equation]="'\\alpha_L'"></ng-katex>
                        (m):</label>
                    <div
                        [ngClass]="{'input-label default-value' : calculationInput.horizontalLongitudinalDispersivity == modelDefaultValues.horizontalLongitudinalDispersivity}">
                        <input name="horizontalLongitudinalDispersivity"
                            [ngModel]="calculationInput.horizontalLongitudinalDispersivity | expNumber : 'horizontalLongitudinalDispersivity' : tempParameters"
                            (ngModelChange)="calculationInput.horizontalLongitudinalDispersivity=localizedParseFloat($event, 'horizontalLongitudinalDispersivity');"
                            placeholder="Indtast dispersitivitet..." type="text" class="form-control text-input"
                            required />
                    </div>
                </div>

                <div class="form-group">
                    <label>Transversal dispersivitet (y-retning), <ng-katex [equation]="'\\alpha_T'"></ng-katex>
                        (m):</label>
                    <div
                        [ngClass]="{'input-label default-value' : calculationInput.horizontalTransversalDispersivity == modelDefaultValues.horizontalTransversalDispersivity}">
                        <input name="horizontalTransversalDispersivity"
                            [ngModel]="calculationInput.horizontalTransversalDispersivity | expNumber : 'horizontalTransversalDispersivity' : tempParameters"
                            (ngModelChange)="calculationInput.horizontalTransversalDispersivity=localizedParseFloat($event, 'horizontalTransversalDispersivity');"
                            placeholder="Indtast dispersitivitet..." type="text" class="form-control text-input"
                            required />
                    </div>
                </div>

                <div class="form-group">
                    <label>Vertikal dispersivitet (z-retning), <ng-katex [equation]="'\\alpha_V'"></ng-katex>
                        (m):</label>
                    <div
                        [ngClass]="{'input-label default-value' : calculationInput.horizontalVerticalDispersivity == modelDefaultValues.horizontalVerticalDispersivity}">
                        <input name="horizontalVerticalDispersivity"
                            [ngModel]="calculationInput.horizontalVerticalDispersivity | expNumber : 'horizontalVerticalDispersivity' : tempParameters"
                            (ngModelChange)="calculationInput.horizontalVerticalDispersivity=localizedParseFloat($event, 'horizontalVerticalDispersivity');"
                            placeholder="Indtast dispersitivitet..." type="text" class="form-control text-input"
                            required />
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-lg-2 mt-3">
                <div class="v-rule"></div>
            </div>

            <div class="col-sm-12 col-lg-6 mt-3">
                <div class="image-card model-image-card" style="width:100%; height:320px; padding: 1rem">
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelI" class="helper-img"
                        style="background-image: url('../assets/Model1_horizontal_transport2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelII" class="helper-img"
                        style="background-image: url('../assets/Model2_horizontal_transport2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelIII" class="helper-img"
                        style="background-image: url('../assets/Model3_horizontal_transport2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelIV" class="helper-img"
                        style="background-image: url('../assets/Model4_horizontal_transport2.png'); "></div>
                    <div *ngIf="calculationInput.modelType == calculationModelType.ModelV" class="helper-img"
                        style="background-image: url('../assets/Model5_horizontal_transport2.png'); "></div>
                </div>

                <div class="form-group mt-5">
                    <label for="exampleFormControlTextarea1">Tilføj kommentar til horisontal transport</label>
                    <textarea class="form-control"
                        (change)="calculationInput.horizontalTransportComment = $event.target.value;"
                        placeholder="Skriv kommentar..."
                        rows="3">{{calculationInput.horizontalTransportComment}}</textarea>
                </div>
            </div>
        </div>

        <!--Sample points-->
        <div class="row mt-5">
            <div class="col">
                <h3 class="calculation-section-header"><span i18n>Kontrolpunkter</span></h3>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-lg-4 mt-3 mb-5">
                <div class="form-group">
                    <label>Der regnes altid i et administrativt punkt i afstand 100 m målt fra forureningskildens
                        nedstrøms kant og med en filterlængde på 2m.</label>
                </div>

                <div *ngIf="(!calculationInput.hasAdditionalPoC)" class="form-group">
                    <a (click)="calculationInput.hasAdditionalPoC = true;"><span style="color:#70B3F8">TILFØJ
                            KONTROLPUNKT</span></a>
                </div>

                <ng-container *ngIf="(calculationInput.hasAdditionalPoC)">
                    <h5 i18n>Valgfrit kontrolpunkt</h5>

                    <div class="form-group">
                        <label>Afstand fra kilde til nedstrøms kontrolpunkt (m):</label>
                        <div>
                            <input name="additionalPoCDistanceFromSource"
                                [ngModel]="calculationInput.additionalPoCDistanceFromSource | expNumber : 'additionalPoCDistanceFromSource' : tempParameters"
                                (ngModelChange)="calculationInput.additionalPoCDistanceFromSource=localizedParseFloat($event, 'additionalPoCDistanceFromSource');"
                                placeholder="Indtast afstand..." type="text" class="form-control text-input" required />
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="pollutant">Filterlængde som koncentrationen i kontrolpunktet midles over
                            (m):</label>
                        <div>
                            <input name="additionalPoCScreenLength"
                                [ngModel]="calculationInput.additionalPoCScreenLength | expNumber : 'additionalPoCScreenLength' : tempParameters"
                                (ngModelChange)="calculationInput.additionalPoCScreenLength=localizedParseFloat($event, 'additionalPoCScreenLength');"
                                placeholder="Indtast filterlængde..." type="text" class="form-control text-input"
                                required />
                        </div>
                    </div>

                    <div class="form-group">
                        <a (click)="calculationInput.hasAdditionalPoC = false;"><span style="color:#70B3F8">FJERN
                                VALGFRIT KONTROLPUNKT</span></a>
                    </div>
                </ng-container>

                <div class="form-group">
                    <label>Indvindingsrate ved nærmeste indvinding (m<sup>3</sup>/år):</label>
                    <div
                        [ngClass]="{'input-label default-value' : calculationInput.abstractionRate == defaultAbstractionRate}">
                        <input name="abstractionRate"
                            [ngModel]="calculationInput.abstractionRate | expNumber : 'abstractionRate' : tempParameters"
                            (ngModelChange)="calculationInput.abstractionRate=localizedParseFloat($event, 'abstractionRate');"
                            placeholder="Indtast indvindingsrate..." type="text" class="form-control text-input"
                            required />
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-lg-2 mt-3">
                <div class="v-rule"></div>
            </div>

            <div class="col-sm-12 col-lg-6 mt-3">
                <div class="form-group mt-1">
                    <label for="exampleFormControlTextarea1">Tilføj kommentar til kontrolpunkter</label>
                    <textarea class="form-control" (change)="calculationInput.pocComment = $event.target.value;"
                        placeholder="Skriv kommentar..." rows="3">{{calculationInput.pocComment}}</textarea>
                </div>
            </div>
        </div>


        <div class="row mt-5 mb-5">
            <hr>
            <div class="col-sm-12 col-lg-12 align-center">
                <p class="text-muted">Udfyld alle parametre og tryk start når du er klar. <b>OBS!</b> Afhængigt af
                    beregningsmodel kan beregningen tage op til 20 min.</p>
                <button class="btn btn-secondary" [disabled]="!contaminantNameControl.valid || isStarting">
                    <b>{{ (isStarting ? 'STARTING...' : 'START') }} <i class="fa fa-play-circle-o fa-lg"></i></b>
                </button>
            </div>
        </div>

    </form>

    <button id="toggleConfirmModalButton" data-toggle="modal" class="d-none" data-target="#confirmModal"></button>

</div>

<!-- pop-up modal for confirm before start risk calculation -->
<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="confirmModal" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body pt-5 px-5 pb-3">
                <h5 i18n>Start ny beregning? </h5>
                <p i18n>
                    Vær opmærksom på, at denne beregning kan tage lang tid at færdiggøre.
                </p>

                <div class="mt-2">
                    <input id="box1" type="checkbox" [checked]="sendMailOnComputationFinished"
                        (change)="sendMailOnComputationFinished = !sendMailOnComputationFinished" />
                    <label class="mb-1" for="box1"><b>Underret mig på mail når beregningen er færdig.</b></label>
                    <div class="form-group ml-3" *ngIf="sendMailOnComputationFinished">
                        <label>En mail vil blive sendt til:</label>
                        <div>
                            <input name="additionalPoCDistanceFromSource" [(ngModel)]="userEmail"
                                placeholder="Din e-mail-adresse..." type="text" class="form-control text-input"
                                required />
                        </div>
                    </div>
                </div>

                <div *ngIf="calculationErrorMessage">
                    <p class="text-danger">{{calculationErrorMessage}}</p>
                </div>
            </div>
            <div class="modal-footer pb-5 px-5 pt-4">
                <button type="button" id="dismissModalButton" class="btn btn-secondary"
                    data-dismiss="modal">Fortryd</button>

                <button type="button" class="btn btn-dark" (click)="confirmStartCalculation()">
                    <i class="fa fa-play-circle-o fa-lg"></i> Start
                </button>
            </div>
        </div>
    </div>
</div>

<!-- pop-up modal for select Geus data -->
<div *ngIf="locationGeusData && locationGeusData.data"
    id="geusDataModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    aria-labelledby="geusDataModal"
    aria-hidden="true">
    <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center" role="document" style="max-width: 90vw;">
            <div class="modal-content">
                <div class="modal-body">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th i18n>Datakvalitet</th>
                                <th i18n>Dæklagtykkelse</th>
                                <th i18n>Dybde til grundvandsmagasin	</th>
                                <th i18n>Dybde til Grundvand	</th>
                                <th i18n>Elevation</th>
                                <th i18n>Flow retning</th>
                                <th i18n>Hydraulisk Gradient</th>
                                <th i18n>Infiltration</th>
                                <th i18n>Lithologi</th>
                                <th i18n>Redox</th>
                                <th i18n>Kompleks geologi</th>
                                <th i18n>Afstand til nærmeste boring uden ler i dæklag</th>
                                <th i18n>Afstand til nærmeste indvinding</th>
                                <th i18n>Forureningsstatus</th>
                                <th i18n>Opdateringsdato</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let geusDataItem of locationGeusData.data; index as itemIndex"
                                (click)="selectGeusDataItem(geusDataItem, itemIndex)"
                                [ngClass]="{
                                    'table-active': itemIndex === selectedItemIndex
                                }">
                                <td i18n>{{ geusDataItem.dataQuality }}</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.coverThickness) }} m</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.aquiferDepth) }} m</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.groundWater) }} m</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.elevation) }} m</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.flowdir) }} m</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.headGradient) }}</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.infiltration) }} mm/år</td>
                                <td>{{ geusDataItem.lithoName }}</td>
                                <td>{{ getNumberWithSignificantDigits(geusDataItem.redox) }}</td>
                                <td i18n>{{ geusDataItem.complexGeology }}</td>
                                <td>{{ geusDataItem.distNoClay | numberOrDefault | number:'1.0-5' }} m</td>
                                <td>{{ geusDataItem.distNearestWaterWell | numberOrDefault | number:'1.0-5' }} m</td>
                                <td>{{ geusDataItem.pollutionStatus }}</td>
                                <td>{{ geusDataItem.updateDate | date:'d/M/yyyy HH:mm' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer pb-5 px-5 pt-4">
                    <button type="button"
                        id="dismissGeusDataModalButton"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        i18n>
                        Annuller
                    </button>
                    <button type="button"
                        class="btn btn-dark"
                        data-dismiss="modal"
                        (click)="finishGeusDataSelection()"
                        [disabled]="!selectedGeusDataItem"
                        i18n>
                        Overfør valgt data
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<span *ngIf="startingGeuscalculation" class="loading-geus-calculation">
    <div class="progress-bar-container">
        <div class="progress">
            <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                role="progressbar"
                [style.width.%]="progress"
            >
            </div>
        </div>
        <span class="progress-bar-text">{{ geusCalculationStatusMessage }}</span>
    </div>
</span>

<div
    id="geusDataCalculateModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    aria-labelledby="geusDataCalculateModal"
    aria-hidden="true">
    <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center" role="document" style="max-width: 30vw;">
            <div class="modal-content">
                <div class="modal-body">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th i18n>Forureningsstatus</th>
                                <th i18n>Flade areal (m2)</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="locationGeusDataCalculated && locationGeusDataCalculated.polygonData">
                            <tr *ngFor="let geusDataItem of locationGeusDataCalculated.polygonData; index as itemIndex"
                                (click)="selectPolygonGeusCalculate(geusDataItem, itemIndex)"
                                [ngClass]="{
                                    'table-active': itemIndex === selectedPolygonIndex
                                }">
                                <td>{{ geusDataItem.pollutionStatusDescription }}</td>
                                <td>{{ geusDataItem.area | number: '1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer pb-5 px-5 pt-4">
                    <button type="button"
                        id="dismissGeusDataModalButton"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        i18n>
                        Annuller
                    </button>
                    <button type="button"
                        class="btn btn-dark"
                        data-dismiss="modal"
                        (click)="startGeusCalculationForSelectedPolygon(selectedPolygon)"
                        [disabled]="!selectedPolygon"
                        i18n>
                        Overfør valgt data
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
